import { Comment } from '@/@types/comment'
import type { ReplyToComment } from '@/components/Comment/types'
import { createContext, useContext } from 'react'

interface CommentActionsContextValue {
	refresh?: () => Promise<any>
	onComment: (replyToComment: ReplyToComment) => void
	onDelete: (data: Comment) => Promise<Comment>
	onTogglePin: (data: Comment) => Promise<Comment>
	onToggleLike: (data: Comment) => Promise<Comment>
}

export const CommentActionsContext = createContext<CommentActionsContextValue>(
	{} as CommentActionsContextValue
)

export const CommentActionsProvider = CommentActionsContext.Provider

export const useCommentActionsContext = () => useContext(CommentActionsContext)
